'use client';

import React from 'react';

export const useIsFirstRender = (): boolean => {
  const isFirstRender = React.useRef(true);
  React.useEffect(() => {
    isFirstRender.current = false;
  }, []);
  return isFirstRender.current;
};
